export default {
  mapToObject (result) {
    var obj = {}
    for (var item in result) {
      var items = item.split('.')
      var objTemp = obj
      for (var i = 0; i < items.length; i++) {
        if (i === items.length - 1) {
          objTemp[items[i]] = result[item]
          break
        } else if (!objTemp[items[i]]) {
          objTemp[items[i]] = {}
        }
        objTemp = objTemp[items[i]]
      }
    }
    return obj
  },

  findValues (obj, key) {
    let result = this.findValuesHelper(obj, key, [], '')
    return result.reduce((obj, item) => {
      obj[item[0]] = item[1]
      return obj
    }, {})
  },

  findValuesHelper (obj, key, list, parentKey) {
    if (!obj) return list
    if (obj instanceof Array) {
      for (var i in obj) {
        let parentKeyFormat = parentKey === '' ? obj[i].key : parentKey + '.' + obj[i].key
        list = list.concat(this.findValuesHelper(obj[i], key, [], parentKeyFormat))
      }
      return list
    }
    if (obj[key]) {
      list.push([parentKey, obj[key]])
    }

    if ((typeof obj === 'object') && (obj !== null)) {
      var children = Object.keys(obj)
      if (children.length > 0) {
        for (i = 0; i < children.length; i++) {
          list = list.concat(this.findValuesHelper(obj[children[i]], key, [], parentKey))
        }
      }
    }
    return list
  },

  findFormComponent (components, key) {
    const keyFirst = key.indexOf('.') > -1 ? key.split('.')[0] : key
    let comp = null
    for (let i = 0; i < components.length; i++) {
      const item = components[i]
      if (item.key === keyFirst) {
        if (item.components && keyFirst !== key) {
          comp = this.findFormComponent(item.components, key.replace(keyFirst + '.', ''))
        } else {
          comp = item
        }
        break
      }
    }
    return comp
  }
}



// WEBPACK FOOTER //
// ./src/utils/object.js